import { Components } from '@ionic/core/dist/types/components';
import {
  IonItemDivider,
  IonLabel,
  IonRadio,
  IonRadioGroup,
  IonText,
} from '@ionic/react';
import { FieldConfig, useField } from 'formik';
import { ReactElement, cloneElement } from 'react';
import { IonItem } from '../ionic/IonItem';

export type RadioOption = {
  label: string;
  value?: string;
  disabled?: boolean;
  ionItem?: ReactElement;
};

export interface IonFormFieldProps extends FieldConfig {
  className?: string;
  label: string;
  radioGroupProps?: Partial<Components.IonRadioGroup>;
  options?: RadioOption[];
}

const IonFormRadioGroupField = (props: IonFormFieldProps): ReactElement => {
  const { label, ...otherProps } = props;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [field, meta, helper] = useField(otherProps as any);

  const radioGroupProps = (otherProps.radioGroupProps ||
    {}) as Components.IonRadioGroup;

  const errorText = <IonText color="danger">{meta.error}</IonText>;

  const options = props.options ?? [];

  return (
    <>
      <IonItemDivider
        style={{
          '--background': 'var(--ion-item-background)',
          border: '0px',
        }}
      >
        <IonLabel color="primary">
          {label} {errorText}
        </IonLabel>
      </IonItemDivider>
      <IonRadioGroup
        aria-label={label}
        {...radioGroupProps}
        value={field.value}
        onIonChange={(e) => {
          if (e.detail.value !== undefined) {
            helper.setValue(e.detail.value);
          }
        }}
      >
        {options.map((option, index) => {
          const lastOption = index === options?.length - 1;

          return option.ionItem ? (
            cloneElement(option.ionItem, {
              key: index,
            })
          ) : (
            <IonItem lines={lastOption ? 'full' : 'none'} key={index}>
              <IonRadio
                disabled={option.disabled === true}
                aria-label={option.label}
                value={option.value}
              >
                {option.label}
              </IonRadio>
            </IonItem>
          );
        })}
      </IonRadioGroup>
    </>
  );
};

export { IonFormRadioGroupField };
